import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'
import forumService from '../../services/forum.service'
import { useReactQuery } from '../../hooks/useReactQuery'
import Header from './components/header'
import { consoleLog, getObjectAsArray, getUserType } from '../../util'
import { Loader, MuiButton, MessageReactQuery } from '../../components'
import { useGlobalStore } from '../../store'
import { NAME_SOCIAL_MONITOR } from '../../constants'

import ContentSection1 from './components/contentSection1'
import ContentSection2 from './components/contentSection2'
import UserProperties from './components/userProperties'
import KeywordVibeMapping from './components/keywordVibeMapping'
import ItemMarketResearchQuestions from './components/itemMarketResearchQuestions'
import MultiChoiceItemMarketResearchQuestions from './components/multiChoiceItemMarketResearchQuestions'
import UserMarketResearchQuestionsLocal from './components/userMarketResearchQuestionsLocal'
import ItemProperties from './components/itemProperties'
import UserMarketResearchQuestionsGlobal from './components/userMarketResearchQuestionsGlobal'
import UserExtendedProperties from './components/userExtendedProperties'
import ErrorBoundary from '../../components/ErrorBoundary'

import { OuterWrapper, Wrapper, ButtonWrapper } from './style'

const SocialMonitorEdit = ({ pageId, onSave, onClose }) => {
  const { user, company } = useGlobalStore()
  const { id } = useParams()
  const [itemData, setItemData] = useState()
  // const [userData, setUserData] = useState()
  const [mode, setMode] = useState('none')
  const [tempUserDetails, setTempUserDetails] = useState({})
  const [expandAll, setExpandAll] = useState(true)
  const [loader, setLoader] = useState(false)
  const [messages, setMessages] = useState(null)
  const [socialMonitorData, setSocialMonitorData] = useState({
    defaultData: {},
    userProperties: {},
    keywordVibeMapping: {},
    itemMarketResearchQuestions: {},
    multiChoiceItemMarketResearchQuestions: {},
    userMarketResearchQuestionsLocal: {},
    itemProperties: {},
    userMarketResearchQuestionsGlobal: {},
    userExtendedProperties: {}
  })

  const useReactQueryObject1 = {
    payloadDetails: {
      queryId: ['AggregationItem'],
      urlFunc: forumService.getOrganizationAggregationItemApi,
      payload: { organizationId: company.OrganizationId, aggregationItemId: id || pageId }
    },
    useReactQueryObject: { cacheTime: 10000 }
  }
  const { data: data1, isLoading: isLoading1, isSuccess: isSuccess1, isError: isError1, error: error1 } = useReactQuery(useReactQueryObject1)

  const loadFormData = () => {
    const payload = { organizationId: company.OrganizationId, aggregationItemId: id || pageId }
    forumService.getOrganizationAggregationItemApi(payload)
      .then((resp) => {
        const defaultObj = {
          AggregationItem: resp?.AggregationItem,
          UserProperties: {},
          KeywordVibeMapping: []
        }
        loadFormData2(resp, defaultObj, company.OrganizationId)
        if (mode !== 'none') {
          onSave()
        }
        setTimeout(() => setLoader(false), 1000)
      })
      .catch((error) => {
        consoleLog('ERROR : ', error)
      })
  }

  const loadFormData2 = (response, defaultObj, organizationId) => {
    const payload = { organizationId: organizationId, aggregationUserId: response?.AggregationItem?.ItemUser?.AggregationUserId }
    forumService.getOrganizationAggregationUserApi(payload)
      .then((resp1) => {
        const resp = resp1
        if (resp === '') {
          return false
        }
        resp.OrganizationAggregationUserLocalFeatures = getObjectAsArray(resp.OrganizationAggregationUserLocalFeatures).map(d => ({ ...d, PropertyValue: d.PropertyValue + '' }))
        const aggregationUserFeatures = {}
        const aggregationUserFeaturesArray = (getObjectAsArray(resp?.AggregationUser?.AggregationUserFeatures).map(d => ({ [d.PropertyName.replaceAll(' ', '')]: d.PropertyValue })))
        for (let i = 0; i < aggregationUserFeaturesArray.length; i++) {
          const key = Object.keys(aggregationUserFeaturesArray[i])[0]
          aggregationUserFeatures[key] = aggregationUserFeaturesArray[i][key]
        }

        const userPropertiesObject = {
          InfluenceLevel: response?.AggregationItem?.InfluenceLevel || '',
          ProcessStep: aggregationUserFeatures?.ProcessStep || '',
          InfluenceType: aggregationUserFeatures?.InfluenceType || '',
          UserName: response?.AggregationItem?.ItemUser?.UserName || '',
          UserUrl: response?.AggregationItem?.ItemUser?.UserProfileUrl || '',
          Gender: aggregationUserFeatures?.Gender || '',
          Age: aggregationUserFeatures?.Age || '',
          BirthYear: aggregationUserFeatures?.BirthYear || '',
          RelationStatus: aggregationUserFeatures?.RelationStatus || '',
          Country: aggregationUserFeatures?.Country || '',
          State: aggregationUserFeatures?.State || '',
          City: aggregationUserFeatures?.City || '',
          Occupation: aggregationUserFeatures?.Occupation || '',
          Education: aggregationUserFeatures?.Education || '',
          Industry: aggregationUserFeatures?.Industry || '',
          CheckedBy: response?.AggregationItem?.CheckedBy || '',
          GlobalQuestion1: aggregationUserFeatures?.GlobalQuestion1 || '',
          GlobalQuestion2: aggregationUserFeatures?.GlobalQuestion2 || ''
        }

        const itemMarketResearchQuestions = () => {
          const itemMarketResearchQuestionsArray = (getObjectAsArray(response?.AggregationItem?.AggregationItemFeatures)?.map(d => ({ [d.PropertyName.replaceAll(' ', '')]: d.PropertyValue })) || [])

          const itemMarketResearchQuestions = {
            MultipleChoiceQuestion1: [],
            MultipleChoiceQuestion2: []
          }
          for (let i = 0; i < itemMarketResearchQuestionsArray.length; i++) {
            const key = Object.keys(itemMarketResearchQuestionsArray[i])[0]
            if (itemMarketResearchQuestionsArray[i]?.['Multiple-choiceQuestion1']) {
              itemMarketResearchQuestions.MultipleChoiceQuestion1.push(itemMarketResearchQuestionsArray[i]['Multiple-choiceQuestion1'])
            } else if (itemMarketResearchQuestionsArray[i]?.['Multiple-choiceQuestion2']) {
              itemMarketResearchQuestions.MultipleChoiceQuestion2.push(itemMarketResearchQuestionsArray[i]['Multiple-choiceQuestion2'])
            } else if (key.indexOf('Description') !== -1) {
              itemMarketResearchQuestions.Description = itemMarketResearchQuestionsArray[i].Description
            } else if (key.indexOf('Language') !== -1) {
              itemMarketResearchQuestions.Language = itemMarketResearchQuestionsArray[i].Language
            } else if (key.indexOf('Question') !== -1) {
              itemMarketResearchQuestions[key] = itemMarketResearchQuestionsArray[i][key]
            }
          }
          return itemMarketResearchQuestions
        }

        const itemProperties = {
          Description: getObjectAsArray(response?.AggregationItem?.AggregationItemFeatures)?.filter(f => f.PropertyName === 'Description')?.[0]?.PropertyValue || '',
          CoreItem: response.AggregationItem.CoreItem,
          Language: getObjectAsArray(response?.AggregationItem?.AggregationItemFeatures)?.filter(f => f.PropertyName === 'Language')?.[0]?.PropertyValue || '',
          Translation: response.AggregationItem.Translation || ''
        }

        const organizationAggregationUserLocalFeatures = () => {
          const organizationAggregationUserLocalFeatures = {}
          const organizationAggregationUserLocalFeaturesArray = (resp?.OrganizationAggregationUserLocalFeatures.map(d => ({ [d.PropertyName.replaceAll(' ', '')]: d.PropertyValue })))
          for (let i = 0; i < organizationAggregationUserLocalFeaturesArray.length; i++) {
            const key = Object.keys(organizationAggregationUserLocalFeaturesArray[i])[0]
            organizationAggregationUserLocalFeatures[key] = organizationAggregationUserLocalFeaturesArray[i][key]
          }
          return organizationAggregationUserLocalFeatures
        }

        const userExtendedProperties = () => {
          const userExtendedProperties = {}
          const userExtendedPropertiesArray = []

          for (let i = 0; i < resp?.AggregationUser?.AggregationUserPropertiesArray.length; i++) {
            const d = resp?.AggregationUser?.AggregationUserPropertiesArray[i]
            if (d !== '') {
              userExtendedPropertiesArray.push(
                { [d?.Category?.replaceAll(' ', '')]: d.PropertyValues.string }
              )
            }
          }

          for (let i = 0; i < userExtendedPropertiesArray.length; i++) {
            const key = Object.keys(userExtendedPropertiesArray[i])[0]
            if (key === 'Interests') {
              // userExtendedProperties.Interests1 = userExtendedPropertiesArray[i][key]
              if (userExtendedPropertiesArray[i][key].indexOf(',') > 0) userExtendedProperties.Interests1 = userExtendedPropertiesArray[i][key]
              else userExtendedProperties.Interests1 = userExtendedPropertiesArray[i][key].join(', ')
            } else {
              userExtendedProperties[key] = userExtendedPropertiesArray[i][key]
            }
          }
          // if (userExtendedProperties?.Occupation) userExtendedProperties.Occupation = resp.AggregationUser.AggregationUserFeatures.filter(f => f?.PropertyName === 'Occupation')?.[0]?.PropertyValue || ''
          // if (userExtendedProperties?.Education) userExtendedProperties.Education = resp.AggregationUser.AggregationUserFeatures.filter(f => f?.PropertyName === 'Education')?.[0]?.PropertyValue || ''
          // if (userExtendedProperties?.Industry) userExtendedProperties.Industry = resp.AggregationUser.AggregationUserFeatures.filter(f => f?.PropertyName === 'Industry')?.[0]?.PropertyValue || ''
          if (userPropertiesObject?.Occupation) userExtendedProperties.Occupation = userPropertiesObject.Occupation || ''
          if (userPropertiesObject?.Education) userExtendedProperties.Education = userPropertiesObject.Education || ''
          if (userPropertiesObject?.Industry) userExtendedProperties.Industry = userPropertiesObject.Industry || ''
          return userExtendedProperties
        }

        defaultObj.UserProperties = userPropertiesObject
        defaultObj.KeywordVibeMapping = response?.AggregationItem?.AggregationItemKeywords
        defaultObj.ItemMarketResearchQuestions = itemMarketResearchQuestions()
        defaultObj.ItemProperties = itemProperties
        defaultObj.OrganizationAggregationUserLocalFeatures = organizationAggregationUserLocalFeatures()
        defaultObj.UserExtendedProperties = userExtendedProperties()

        setSocialMonitorData(prev => ({ ...prev, defaultData: defaultObj }))
        setItemData(response)
        // setUserData(resp)
      })
      .catch((error) => {
        consoleLog('ERROR : ', error)
      })
  }

  const userPropertiesFunc = (data) => {
    setSocialMonitorData(prev => ({ ...prev, userProperties: data }))
  }
  const keywordVibeMappingFunc = (data) => {
    setSocialMonitorData(prev => ({ ...prev, keywordVibeMapping: data }))
  }
  const itemMarketResearchQuestionsFunc = (data) => {
    setSocialMonitorData(prev => ({ ...prev, itemMarketResearchQuestions: data }))
  }
  const multiChoiceItemMarketResearchQuestionsFunc = (data) => {
    setSocialMonitorData(prev => ({ ...prev, multiChoiceItemMarketResearchQuestions: data }))
  }
  const userMarketResearchQuestionsLocalFunc = (data) => {
    setSocialMonitorData(prev => ({ ...prev, userMarketResearchQuestionsLocal: data }))
  }
  const itemPropertiesFunc = (data) => {
    setSocialMonitorData(prev => ({ ...prev, itemProperties: data }))
  }
  const userMarketResearchQuestionsGlobalFunc = (data) => {
    setSocialMonitorData(prev => ({ ...prev, userMarketResearchQuestionsGlobal: data }))
  }
  const userExtendedPropertiesFunc = (data) => {
    setSocialMonitorData(prev => ({ ...prev, userExtendedProperties: data }))
  }

  const onSaveFunc = () => {
    const aggregationUserFeatureFunc = () => {
      // COMPONENT - User Properties
      // WORKING PROPERLY
      const finalData = []
      const key = Object.keys(socialMonitorData.userProperties)
      let hasProcessStep = false
      for (let i = 0; i < key.length; i++) {
        if (key[i] === 'ProcessStep') { hasProcessStep = true }
        finalData.push({ AggregationUserFeature: { AggregationUserId: user?.UserId || user?.user?.UserId, PropertyName: key[i], PropertyValue: socialMonitorData.userProperties[key[i]] } })
      }
      if (!hasProcessStep) {
        finalData.push({ AggregationUserFeature: { AggregationUserId: user?.UserId || user?.user?.UserId, PropertyName: 'ProcessStep', PropertyValue: 'Analyze' } })
      }
      finalData.push({ AggregationUserFeature: { AggregationUserId: user?.UserId || user?.user?.UserId, PropertyName: 'Global Question 1', PropertyValue: socialMonitorData.userMarketResearchQuestionsGlobal.globalQuestion1 || '' } })
      finalData.push({ AggregationUserFeature: { AggregationUserId: user?.UserId || user?.user?.UserId, PropertyName: 'Global Question 2', PropertyValue: socialMonitorData.userMarketResearchQuestionsGlobal.globalQuestion2 || '' } })

      // Occupation: aggregationUserFeatures?.Occupation || '',
      // Education: aggregationUserFeatures?.Education || '',
      // Industry: aggregationUserFeatures?.Industry || '',
      if (socialMonitorData?.userExtendedProperties?.Occupation) finalData.push({ AggregationUserFeature: { AggregationUserId: user?.UserId || user?.user?.UserId, PropertyName: 'Occupation', PropertyValue: socialMonitorData.userExtendedProperties.Occupation || '' } })
      if (socialMonitorData?.userExtendedProperties?.Education) finalData.push({ AggregationUserFeature: { AggregationUserId: user?.UserId || user?.user?.UserId, PropertyName: 'Education', PropertyValue: socialMonitorData.userExtendedProperties.Education || '' } })
      if (socialMonitorData?.userExtendedProperties?.Industry) finalData.push({ AggregationUserFeature: { AggregationUserId: user?.UserId || user?.user?.UserId, PropertyName: 'Industry', PropertyValue: socialMonitorData.userExtendedProperties.Industry || '' } })

      return finalData
    }

    const aggregationItemKeywordFunc = () => {
      // COMPONENT - Keyword Vibe Mapping
      // WORKING PROPERLY

      const sortKeywords = getObjectAsArray(socialMonitorData?.keywordVibeMapping, 'adv')?.map(f => f.keyword)?.filter(f => f.keyword !== '')?.filter(f => f.keyword !== ' ')?.sort() || []
      const sortArray = []

      const filterArr = (arr, key) => {
        let obj = {}
        let index = -1
        for (let j = 0; j < arr.length; j++) {
          if (arr[j].keyword === key) {
            obj = arr[j]
            index = j
            break
          }
        }
        return { obj, index }
      }

      if (socialMonitorData.keywordVibeMapping.length > 0) {
        const tempArray = [...socialMonitorData.keywordVibeMapping]
        for (let i = 0; i < sortKeywords.length; i++) {
          const obj = filterArr(tempArray, sortKeywords[i])
          if (obj.index !== -1) {
            sortArray.push({ ...obj.obj })
            tempArray[obj.index].keyword = tempArray[i].keyword + '___'
          }
        }
      }

      const sortedArray = sortArray.filter(f => f.keywordId !== '').filter(f => f.keywordId !== ' ')
      // socialMonitorData.keywordVibeMapping = sortedArray
      setSocialMonitorData(prev => ({ ...prev, keywordVibeMapping: sortedArray }))

      return sortedArray.map(d => {
        const obj = { KeywordId: d.keywordId }
        if (d?.keywordSearchTerm) obj.KeywordSearchTerm = d.keywordSearchTerm
        if (d?.vibe) obj.KeywordVibe = d.vibe
        if (d?.notes) obj.KeywordNotes = d.notes
        if (d?.verbatim) obj.KeywordVerbatim = encodeURIComponent(d.verbatim)
        if (d?.mediaLink) obj.KeywordVerbatimMediaPublicLink = d.mediaLink
        if (d?.s3Name) obj.KeywordVerbatimMediaPrivateName = d.s3Name
        if (d?.type) obj.KeywordType = d.type
        if (d?.subType) obj.KeywordSubType = d.subType
        if (d?.subKeywordLevel1) obj.SubKeywordLevel1 = d.subKeywordLevel1
        if (d?.keyword) obj.KeywordValue = d.keyword
        if (d?.subKeywordLevel2) obj.SubKeywordLevel2 = d.subKeywordLevel2

        return { AggregationItemKeyword: obj }
      })
    }

    const aggregationItemFeatureFunc = () => {
      // COMPONENT - Multi-choice Item Market Research Questions
      // WORKING PROPERLY

      // COMPONENT - Item Market Research Questions
      // WORKING PROPERLY

      const finalData = []
      for (let i = 0; i < socialMonitorData?.multiChoiceItemMarketResearchQuestions?.multipleChoiceQuestion1?.length || 0; i++) {
        finalData.push({ AggregationItemFeature: { AggregationItemId: '00000000-0000-0000-0000-000000000000', PropertyName: 'Multiple-choice Question 1', PropertyValue: socialMonitorData?.multiChoiceItemMarketResearchQuestions?.multipleChoiceQuestion1[i].label } })
      }
      for (let i = 0; i < socialMonitorData?.multiChoiceItemMarketResearchQuestions?.multipleChoiceQuestion2?.length || 0; i++) {
        finalData.push({ AggregationItemFeature: { AggregationItemId: '00000000-0000-0000-0000-000000000000', PropertyName: 'Multiple-choice Question 2', PropertyValue: socialMonitorData?.multiChoiceItemMarketResearchQuestions?.multipleChoiceQuestion2[i].label } })
      }

      const keys = Object.keys(socialMonitorData?.itemMarketResearchQuestions)
      for (let i = 0; i < keys.length; i++) {
        if (keys[i].indexOf('choice') === -1) {
          if (keys[i].indexOf('Question') !== -1) {
            finalData.push({ AggregationItemFeature: { AggregationItemId: '00000000-0000-0000-0000-000000000000', PropertyName: keys[i].replaceAll(' ', '').replaceAll('Question', 'Question '), PropertyValue: socialMonitorData?.itemMarketResearchQuestions[keys[i].replaceAll(' ', '')] } })
          }
        }
      }

      if (socialMonitorData?.itemProperties?.Language) {
        finalData.push({ AggregationItemFeature: { AggregationItemId: '00000000-0000-0000-0000-000000000000', PropertyName: 'Language', PropertyValue: socialMonitorData.itemProperties.Language } })
      }
      if (socialMonitorData?.itemProperties?.Description) {
        finalData.push({ AggregationItemFeature: { AggregationItemId: '00000000-0000-0000-0000-000000000000', PropertyName: 'Description', PropertyValue: socialMonitorData.itemProperties.Description } })
      }

      return finalData
    }

    const aggregationUserPropertiesFunc = () => {
      const finalData = []
      const keys = Object.keys(socialMonitorData.userExtendedProperties)
      for (let i = 0; i < keys.length; i++) {
        if (socialMonitorData.userExtendedProperties[keys[i].replaceAll(' ', '')].length > 0) {
          finalData.push({ AggregationUserProperties: { Category: keys[i], PropertyValues: { string: socialMonitorData.userExtendedProperties[keys[i].replaceAll(' ', '')] } } })
        }
      }
      return finalData
      // return userData.AggregationUser.AggregationUserPropertiesArray.map(d => {
      //   if (d === '') {
      //     return { AggregationUserProperties: { Category: '', PropertyValues: { string: '' } } }
      //   } else {
      //     d.PropertyValues.string = socialMonitorData.userExtendedProperties[d.Category.replaceAll(' ', '')]
      //     return { AggregationUserProperties: d }
      //   }
      // })
    }

    const organizationAggregationUserLocalFeatureFunc = () => {
      const finalData = []
      const keys = Object.keys(socialMonitorData.userMarketResearchQuestionsLocal)
      for (let i = 0; i < keys.length; i++) {
        if (socialMonitorData.userMarketResearchQuestionsLocal[keys[i]].length > 0) {
          finalData.push({
            OrganizationAggregationUserLocalFeature: {
              AggregationUserId: user?.UserId || user?.user?.UserId,
              PropertyName: keys[i].replace('LocalQuestion', 'Local Question '),
              PropertyValue: socialMonitorData.userMarketResearchQuestionsLocal[keys[i]]
            }
          })
        }
      }
      return finalData
    }

    const processStepData = {
      EditedBy: mode === 'edit' ? (user?.EmailAddress || user?.user?.EmailAddress) : itemData?.AggregationItem.EditedBy,
      CheckedBy: itemData?.AggregationItem?.CheckedBy || 'NONE',
      QCBy: itemData?.AggregationItem?.QCBy || 'TBD',
      RecheckedBy: itemData?.AggregationItem?.RecheckedBy || 'NA',
      updatedType: 'Edited'
    }

    if (mode === 'process') {
      if (socialMonitorData.userProperties.ProcessStep === 'QC') {
        processStepData.QCBy = (user?.EmailAddress || user?.user?.EmailAddress)
        processStepData.updatedType = 'QCed'
      } else if (socialMonitorData.userProperties.ProcessStep === 'Reanalyze') {
        processStepData.RecheckedBy = (user?.EmailAddress || user?.user?.EmailAddress)
        processStepData.updatedType = 'Rechecked'
      } else {
        processStepData.CheckedBy = (user?.EmailAddress || user?.user?.EmailAddress)
        processStepData.updatedType = 'Checked'
      }
    }

    const updateAggregationItemAndUser = {
      sourceName: socialMonitorData.userProperties.InfluenceType,
      organizationId: company?.OrganizationId,
      aggregationItemId: itemData.AggregationItem.AggregationItemId,
      aggregationUserId: itemData.AggregationItem?.ItemUser?.AggregationUserId,
      itemWeight: 0,
      userName: socialMonitorData.userProperties.UserName,
      userProfileUrl: socialMonitorData.userProperties.UserUrl,
      coreItem: encodeURIComponent(socialMonitorData.itemProperties.CoreItem),
      translation: encodeURIComponent(socialMonitorData.itemProperties.Translation),
      editedBy: processStepData.EditedBy,
      checkedBy: processStepData.CheckedBy,
      QCBy: processStepData.QCBy,
      recheckedBy: processStepData.RecheckedBy,

      aggregationItemKeywords: aggregationItemKeywordFunc(), // WORKING PROPERLY
      aggregationUserFeatures: aggregationUserFeatureFunc(), // WORKING PROPERLY
      aggregationItemFeatures: aggregationItemFeatureFunc(), // WORKING PROPERLY

      aggregationUserPropertiesArray: aggregationUserPropertiesFunc(),
      organizationAggregationUserLocalFeatures: organizationAggregationUserLocalFeatureFunc(),
      numberOfFriends: 0,
      updatedType: processStepData.updatedType
    }

    setTempUserDetails(processStepData)
    setLoader(true)

    const payload = updateAggregationItemAndUser
    forumService.updateAggregationItemAndUserApi(payload)
      .then((resp) => {
        if (resp?.code === 'ERR_BAD_RESPONSE') {
          setMessages({ type: 'error', msg: 'Item not saved!', error: resp.response.data })
          setLoader(false)
        } else {
          setSocialMonitorData({
            defaultData: {},
            userProperties: {},
            keywordVibeMapping: {},
            itemMarketResearchQuestions: {},
            multiChoiceItemMarketResearchQuestions: {},
            userMarketResearchQuestionsLocal: {},
            itemProperties: {},
            userMarketResearchQuestionsGlobal: {},
            userExtendedProperties: {}
          })
          loadFormData()
          setMode('none')
          setMessages({ type: 'success', msg: 'Item saved successfully!' })
          setTimeout(() => setMessages(null), 2500)
          setLoader(false)
        }
      })
      .catch((error) => {
        consoleLog('ERROR : ', error)
        setMessages({ type: 'error', msg: 'Item not saved!', error: error })
        setLoader(false)
      })
  }

  const onCancelFunc = () => {
    setMode('none')
  }
  const onEditFunc = () => {
    setMode('edit')
  }
  const onProcessFunc = () => {
    setMode('process')
  }
  const onCloseFunc = (id) => {
    onClose(id, tempUserDetails)
  }

  useEffect(() => {
    if (company?.OrganizationId) loadFormData()
  }, [company])

  useEffect(() => {
    document.title = NAME_SOCIAL_MONITOR
  }, [])

  const onSuccess1Func = (resp) => {
    const defaultObj = {
      AggregationItem: resp?.AggregationItem,
      UserProperties: {},
      KeywordVibeMapping: []
    }
    loadFormData2(resp, defaultObj, company.OrganizationId)
    if (mode !== 'none') {
      onSave()
    }
    setTimeout(() => setLoader(false), 1000)
  }
  useEffect(() => {
    if (isSuccess1 && data1?.length) onSuccess1Func(data1)
  }, [isSuccess1, data1])

  return (
    <OuterWrapper>
      <MessageReactQuery
        isLoading={isLoading1}
        isSuccess={isSuccess1}
        data={data1}
        isError={isError1}
        error={error1}
      />
      <Header data={socialMonitorData} loading={loader} messages={messages} onSave={onSaveFunc} onCancel={onCancelFunc} onEdit={onEditFunc} onProcess={onProcessFunc} mode={mode} isPageId={pageId} onClose={onCloseFunc} />
      { socialMonitorData?.defaultData?.AggregationItem && company?.OrganizationId && (user?.user?.UserId || user?.UserId)
        ? <Wrapper id='socialMonitorEditWrapper'>
            <ErrorBoundary componentName='ContentSection1'>
              <ContentSection1 data={socialMonitorData.defaultData} />
            </ErrorBoundary>
            <ButtonWrapper>
              <MuiButton variant='standard' color='primary' onClick={() => setExpandAll(true)} className={expandAll ? 'expanded' : ''}>Expand All</MuiButton>
              <span> | </span>
              <MuiButton variant='standard' color='primary' onClick={() => setExpandAll(false)} className={expandAll ? '' : 'collapsed'}>Collapse All</MuiButton>
            </ButtonWrapper>
            <ErrorBoundary componentName='ContentSection2'>
              <ContentSection2 data={socialMonitorData.defaultData} />
            </ErrorBoundary>
            <ErrorBoundary componentName='UserProperties'>
              <UserProperties mode={mode} data={(socialMonitorData.defaultData.UserProperties)} onChange={userPropertiesFunc} expanded={expandAll} />
            </ErrorBoundary>
            <ErrorBoundary componentName='KeywordVibeMapping'>
              <KeywordVibeMapping mode={mode === 'none'} data={getObjectAsArray(socialMonitorData.defaultData.KeywordVibeMapping)} onChange={keywordVibeMappingFunc} expanded={expandAll} />
            </ErrorBoundary>
            <ErrorBoundary componentName='ItemMarketResearchQuestions'>
              <ItemMarketResearchQuestions mode={mode === 'none'} data={socialMonitorData.defaultData.ItemMarketResearchQuestions} onChange={itemMarketResearchQuestionsFunc} expanded={expandAll} />
            </ErrorBoundary>
            <ErrorBoundary componentName='MultiChoiceItemMarketResearchQuestions'>
              <MultiChoiceItemMarketResearchQuestions mode={mode === 'none'} data={socialMonitorData.defaultData.ItemMarketResearchQuestions} onChange={multiChoiceItemMarketResearchQuestionsFunc} expanded={expandAll} />
            </ErrorBoundary>
            <ErrorBoundary componentName='UserMarketResearchQuestionsLocal'>
              <UserMarketResearchQuestionsLocal mode={mode === 'none'} data={socialMonitorData.defaultData.OrganizationAggregationUserLocalFeatures} onChange={userMarketResearchQuestionsLocalFunc} expanded={expandAll} />
            </ErrorBoundary>
            <ErrorBoundary componentName='ItemProperties'>
              <ItemProperties mode={mode === 'none'} data={socialMonitorData.defaultData.ItemProperties} onChange={itemPropertiesFunc} expanded={expandAll} />
            </ErrorBoundary>
            <ErrorBoundary componentName='UserMarketResearchQuestionsGlobal'>
              <UserMarketResearchQuestionsGlobal mode={mode === 'none'} data={socialMonitorData.defaultData.UserProperties} onChange={userMarketResearchQuestionsGlobalFunc} expanded={expandAll} />
            </ErrorBoundary>
            <ErrorBoundary componentName='UserExtendedProperties'>
              {(getUserType(user).value === 0) && <UserExtendedProperties mode={mode === 'none'} data={socialMonitorData.defaultData.UserExtendedProperties} onChange={userExtendedPropertiesFunc} expanded={expandAll} />}
            </ErrorBoundary>
          </Wrapper>
        : <Wrapper><Loader /></Wrapper>
      }
    </OuterWrapper>
  )
}

SocialMonitorEdit.propTypes = {
  pageId: PropTypes.string,
  onSave: PropTypes.func,
  onClose: PropTypes.func
}

export default SocialMonitorEdit
